var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInitalBlackArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 9,
    viewBox: "0 0 5 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.17965 0.116287C0.281508 0.0314542 0.412885 -0.00945836 0.544899 0.00254291C0.676913 0.0145442 0.798759 0.0784767 0.88365 0.180286L4.21665 4.18029C4.26055 4.23047 4.29397 4.28892 4.31494 4.3522C4.33592 4.41549 4.34402 4.48233 4.33879 4.54879C4.33355 4.61526 4.31507 4.68 4.28444 4.73922C4.25381 4.79844 4.21164 4.85093 4.16042 4.89362C4.10921 4.9363 4.04997 4.96831 3.9862 4.98776C3.92243 5.00721 3.85541 5.01371 3.78909 5.00687C3.72277 5.00004 3.65849 4.98001 3.60002 4.94797C3.54156 4.91593 3.49009 4.87251 3.44865 4.82029L0.11565 0.820287C0.030817 0.718428 -0.0100951 0.587051 0.0019059 0.455037C0.0139069 0.323023 0.0778403 0.201178 0.17965 0.116287Z",
    fill: "#0A0B26"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.17965 8.88419C0.0778401 8.79929 0.0139068 8.67745 0.00190572 8.54543C-0.0100953 8.41342 0.0308168 8.28204 0.11565 8.18019L3.44865 4.18019C3.49009 4.12796 3.54156 4.08455 3.60002 4.0525C3.65849 4.02046 3.72277 4.00043 3.78909 3.9936C3.85541 3.98677 3.92243 3.99327 3.9862 4.01272C4.04997 4.03217 4.10921 4.06417 4.16042 4.10686C4.21164 4.14954 4.25381 4.20203 4.28444 4.26125C4.31507 4.32047 4.33355 4.38521 4.33879 4.45168C4.34402 4.51814 4.33592 4.58498 4.31494 4.64827C4.29397 4.71155 4.26055 4.77001 4.21665 4.82019L0.883649 8.82019C0.798758 8.92199 0.676913 8.98593 0.544899 8.99793C0.412885 9.00993 0.281508 8.96902 0.17965 8.88419Z",
    fill: "#0A0B26"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInitalBlackArrow);
export default __webpack_public_path__ + "static/media/inital_black_arrow.65a97097c9281cdd29b44ec8b446ab2e.svg";
export { ForwardRef as ReactComponent };